import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import React from "react";
import { useQuickTourVideo } from "../../../hooks/react-query/video/useQuickTourVideo";

export const QuickTourCard = () => {
  // Backend now live (NS-1011, GET /video + GET /video/{id}) - see useQuickTourVideo for the
  // two-step id-lookup-then-signed-URL fetch this wraps.
  const { playbackUrl } = useQuickTourVideo();

  return (
    <div className="cedar_home_quick_tour_card" data-test-id="cedar-home-quick-tour-card">
      <div className="cedar_home_quick_tour_card_header">
        <PlayCircleOutlineIcon fontSize="small" />
        <h2 className="cedar_home_quick_tour_card_title">QUICK TOUR</h2>
      </div>
      <p className="cedar_home_quick_tour_card_text">A short walk-through of CEDAR Home for new users.</p>
      {playbackUrl && (
        // Stopped by default, not autoplaying - this card is on Home, which anyone without a
        // custom home page lands on every time they log in (potentially daily); autoplaying the
        // same video on every single visit isn't friendly, and unmuting it after the fact was an
        // extra step nobody was doing anyway. controls-only means the user clicks play themselves
        // - a direct user gesture, so it can start with sound immediately rather than needing the
        // old muted-autoplay-then-manually-unmute dance.
        <video
          className="cedar_home_quick_tour_card_video"
          src={playbackUrl}
          controls
          playsInline
          data-test-id="cedar-home-quick-tour-video"
        />
      )}
    </div>
  );
};
